import { latestBrandReleases } from "../../../shared/brand-latest/latestReleases";

export const newBooksData = [
  ...latestBrandReleases
    .filter((book) => book.brandSlug === "qianhua-tech")
    .map((book) => ({
      title: book.title,
      author: book.author,
      isbn: book.isbn,
      cover: book.coverImage,
      publishDate: book.publishDate,
    })),
  {
    title: "祭祀廟宇：香火旺盛的各地神廟",
    author: "肖東發 主編 / 孫鵬飛 編著",
    isbn: "9786264073318",
    cover:
      "https://storage.helloreaddy.io/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/7ede7065-ceaf-467e-9a38-75ea59c2bf07_compressed_9786264073318.webp",
  },
  {
    title: "金光燦爛：藏傳佛教的著名寺院",
    author: "肖東發 主編 / 潘玉峰 編著",
    isbn: "9786264073257",
    cover:
      "https://storage.helloreaddy.io/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/702e85c2-80bf-4ee8-9113-a4144434f5ec_compressed_9786264073257.webp",
  },
  {
    title: "在人心失序的時代，重讀中華文化",
    author: "樓宇烈 著",
    isbn: "9786264073240",
    cover:
      "https://storage.helloreaddy.io/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/1ffe23a9-22d4-490f-abb6-0b1ea864ad0b_compressed_9786264073240.webp",
  },
  {
    title: "天下祭壇：北京祭壇的絕妙密碼",
    author: "肖東發 主編 / 顧文超 編著",
    isbn: "9786264073196",
    cover:
      "https://storage.helloreaddy.io/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/13e071e6-445b-48af-b1ee-bd77a8e94d21_compressed_9786264073196_3D_72dpi.webp",
  },
  {
    title: "兩棵花椒樹：在愛與現實之間，那些無聲崩塌的人生",
    author: "姚鄂梅 著",
    isbn: "9786264073189",
    cover:
      "https://storage.helloreaddy.io/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/eefbf67d-d37c-45c0-b5b6-bd2887ce9639_compressed_9786264073189_3D_72dpi.webp",
  },
];
